import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { FaDatabase } from "react-icons/fa";
import Input from "../ui/Input";

const OtherSourcesIncomeForm = ({ control, isPOI = false }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      {/* Accordion Header */}
      <div 
        className="flex items-center justify-between p-4 bg-white cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-3">
          <FaDatabase className="w-5 h-5 text-gray-600" />
          <span className="text-base font-medium text-gray-900">
            Other Sources of Income
          </span>
        </div>
        <div className="flex items-center">
          {isExpanded ? (
            <MdKeyboardArrowUp className="w-5 h-5 text-gray-500" />
          ) : (
            <MdKeyboardArrowDown className="w-5 h-5 text-gray-500" />
          )}
        </div>
      </div>

      {/* Accordion Content */}
      {isExpanded && (
        <div className="border-t border-gray-200 px-6 py-6 space-y-6 bg-white">
          {isPOI ? (
            // POI Mode: 3-column layout aligned with sticky header
            <div className="space-y-6">
              {/* Income from other sources Row */}
              <div className="flex w-full gap-4">
                <div className="w-1/3 flex items-center">
                  <label className="text-sm font-medium text-gray-900">
                    Income from other sources
                  </label>
                </div>
                <div className="w-1/3 flex justify-center">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.income_from_other_sources"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      disabled={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
                <div className="w-1/3 flex justify-center">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.actual_income_from_other_sources"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
              </div>

              {/* Interest Earned from Savings Deposit Row */}
              <div className="flex w-full gap-4">
                <div className="w-1/3 flex items-center">
                  <label className="text-sm font-medium text-gray-900">
                    Interest Earned from Savings Deposit
                  </label>
                </div>
                <div className="w-1/3 flex justify-center">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.interest_from_savings"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      disabled={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
                <div className="w-1/3 flex justify-center">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.actual_interest_from_savings"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
              </div>

              {/* Interest Earned from Fixed Deposit Row */}
              <div className="flex w-full gap-4">
                <div className="w-1/3 flex items-center">
                  <label className="text-sm font-medium text-gray-900">
                    Interest Earned from Fixed Deposit
                  </label>
                </div>
                <div className="w-1/3 flex justify-center">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.interest_from_fixed_deposits"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      disabled={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
                <div className="w-1/3 flex justify-center">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.actual_interest_from_fixed_deposits"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
              </div>

              {/* Interest Earned from National Savings Certificates Row */}
              <div className="flex w-full gap-4">
                <div className="w-1/3 flex items-center">
                  <label className="text-sm font-medium text-gray-900">
                    Interest Earned from National Savings Certificates
                  </label>
                </div>
                <div className="w-1/3 flex justify-center">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.interest_from_national_savings"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      disabled={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
                <div className="w-1/3 flex justify-center">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.actual_interest_from_national_savings"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            // Declaration Mode: 2-column layout with separate labels
            <div className="space-y-6">
              {/* Income from other sources Row */}
              <div className="flex w-full gap-4">
                <div className="w-3/5 flex items-center">
                  <label className="text-sm font-medium text-gray-900">
                    Income from other sources
                  </label>
                </div>
                <div className="w-2/5 flex justify-end">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.income_from_other_sources"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
              </div>

              {/* Interest Earned from Savings Deposit Row */}
              <div className="flex w-full gap-4">
                <div className="w-3/5 flex items-center">
                  <label className="text-sm font-medium text-gray-900">
                    Interest Earned from Savings Deposit
                  </label>
                </div>
                <div className="w-2/5 flex justify-end">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.interest_from_savings"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
              </div>

              {/* Interest Earned from Fixed Deposit Row */}
              <div className="flex w-full gap-4">
                <div className="w-3/5 flex items-center">
                  <label className="text-sm font-medium text-gray-900">
                    Interest Earned from Fixed Deposit
                  </label>
                </div>
                <div className="w-2/5 flex justify-end">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.interest_from_fixed_deposits"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
              </div>

              {/* Interest Earned from National Savings Certificates Row */}
              <div className="flex w-full gap-4">
                <div className="w-3/5 flex items-center">
                  <label className="text-sm font-medium text-gray-900">
                    Interest Earned from National Savings Certificates
                  </label>
                </div>
                <div className="w-2/5 flex justify-end">
                  <div className="w-full max-w-xs">
                    <Input
                      control={control}
                      name="other_source_income.interest_from_national_savings"
                      type="number"
                      isCurrency={true}
                      placeholder="0"
                      isPositiveNumber={true}
                      hideLabel={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OtherSourcesIncomeForm;
